<template>
  <ul class="menu">
    <li>
      <a href="#" @click.prevent><img src="@/assets/img/menu.svg"/></a>

      <!-- Logged in menu -->
      <ul class="submenu" v-if="currentUserProfile">
        <li v-if="!isAdmin"><router-link to="/dashboard">Timeline</router-link></li>
        <li v-if="isAdmin"><router-link to="/clients">Clients</router-link></li>
        <li><router-link to="/update-profile">Profile</router-link></li>
        <li v-if="!isAdmin"><router-link to="/documents">My Documents</router-link></li>
        <li v-if="!isAdmin"><router-link to="/contact">Contact</router-link></li>
        <li v-if="isAdmin"><router-link to="/settings">Settings</router-link></li>
        <li>
          <a @click="logout()">Log out</a>
        </li>
      </ul>

      <!-- Public-facing menu -->
      <ul class="submenu" v-else>
        <li><router-link to="/packages">Packages &amp; Pricing</router-link></li>
        <li><router-link to="/company">Company</router-link></li>
        <!-- <li><router-link to="/faq">FAQ</router-link></li> -->
        <li><router-link to="/contact">Contact</router-link></li>
        <li><router-link to="/login">Log in</router-link></li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'Menu',
  computed: {
    ...mapGetters([
      'currentUserProfile'
    ]),
    ...mapState([
      'isAdmin'
    ])
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: inline-block;
    position: relative;
    margin: 0;

    &:hover ul.submenu {
      display: block;
    }

    // Hamburger menu button
    a {
      display: inline-block;
      padding: .75rem;
    }

    ul.submenu {
      display: none;
      position: absolute;
      padding: 0;
      top: 50px;
      right: 0;
      text-align: left;
      width: 16rem;
      background: white;
      border: solid 1px $c-border;
      z-index: 2;

      li {
        display: block;
        a {
          display: block;
          padding: .75rem;
          color: #333;
          &:hover {
            background: linear-gradient(12deg, #ddd, #fff)
          }
        }
        /deep/ {
          .router-link-exact-active {
            font-weight: bold;
            border-left: solid 2px #1e9db2;
          }
        }
      }
    }
  }
}
</style>